var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.version > _vm.currentSettingsVersion
    ? _c("div", { staticClass: "new-tag" }, [_vm._v("\n  New\n")])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }